import axios from 'axios'
export default {
  state: {
    achievements: null,
    userPrizes: [],
  },
  getters: {
    Achievements: (s) => s.achievements,
    UserPrizes: (s) => s.userPrizes,
  },
  mutations: {
    setAchievements: (s, list) => (s.achievements = list),
    setUserPrizes: (s, list) => (s.userPrizes = list),
  },
  actions: {
    fetchAchievements(ctx) {
      return axios({
        method: 'GET',
        url: `api/motivation/stats`,
      })
        .then((response) => {
          ctx.commit('setAchievements', response.data)
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    fetchUserPrizes(ctx) {
      return axios({
        method: 'GET',
        url: `api/gamification/user-prize/`,
      })
        .then((response) => {
          ctx.commit('setUserPrizes', response.data.results)
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    buyUserPrize(ctx, slug) {
      return axios({
        method: 'POST',
        url: `api/gamification/user-prize/`,
        data: { slug: slug },
      })
        .then(() => {
          ctx.dispatch('fetchUserPrizes')
          ctx.dispatch('fetchSession')
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
  },
}
